import * as angular from "angular";
import {IController} from 'angular';
import {PdfFormTextTagType} from "../../types/pdf-form-text-tag.type";

export class PdfFormTextTagSelectComponent implements IController {

  pdfFormTextTag: any;
  inputName?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  onChange: Function;

  public pdfFormTextTagTypes: PdfFormTextTagType[];

  /* @ngInject */
  constructor() {
    this.pdfFormTextTagTypes = Object.values(PdfFormTextTagType);
  }

  $onInit() {
    if (!this.inputName) {
      this.inputName = 'PdfFormTextTag'
    }
  };

  $onChanges(changes) {
    if ((changes.inputName && !changes.inputName.isFirstChange())) {
      if (!this.inputName) {
        this.inputName = 'PdfFormTextTag'
      }
    }
  };


}

angular
  .module('bringoz.admin.document-management')
  .component('pdfFormTextTagSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      pdfFormTextTag: '<?',
      inputName: '@?',
      isRequired: '<?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./pdf-form-text-tag-select.html').default,
    controller: PdfFormTextTagSelectComponent
  });
